/**
 * @module "ethpm/registries/web3"
 */

import Web3RegistryConnector from './service';

export * from './service';
export default Web3RegistryConnector;
